import type { RenderConfig } from '../types/becky'

export const InitSymbol = Symbol('InitSymbol')

export type FeatureName =
	| 'accessibility'
	| 'accessibilityBrowserZoom'
	| 'activePopup'
	| 'activeVariantsApi'
	| 'addressInput'
	| 'anchorsService'
	| 'animations'
	| 'animationsWixCodeSdk'
	| 'appMonitoring'
	| 'applePay'
	| 'assetsLoader'
	| 'authenticationWixCodeSdk'
	| 'autoDisplayLightbox'
	| 'backgroundGroup'
	| 'backgroundScrub'
	| 'blockingLayer'
	| 'bookings'
	| 'breadcrumbs'
	| 'builderComponent'
	| 'builderComponentHierarchy'
	| 'builderComponentRefs'
	| 'builderContextProviders'
	| 'builderModuleLoader'
	| 'businessLogger'
	| 'businessLoggerService'
	| 'businessManager'
	| 'canvas'
	| 'captcha'
	| 'chat'
	| 'clickHandlerRegistrar'
	| 'clientSdk'
	| 'coBranding'
	| 'codeEmbed'
	| 'commonConfig'
	| 'componentCustomCss'
	| 'components'
	| 'componentsLoader'
	| 'componentsMeasures'
	| 'componentsPreviewTooltip'
	| 'componentsQaApi'
	| 'componentsReact'
	| 'componentsRegistry'
	| 'componentsUpdatesManager'
	| 'consentPolicy'
	| 'consentPolicyService'
	| 'containerSlider'
	| 'containerSliderService'
	| 'contentReflow'
	| 'cookiesManager'
	| 'crmWixCodeSdk'
	| 'customCss'
	| 'customUrlMapper'
	| 'cyclicTabbing'
	| 'cyclicTabbingService'
	| 'dashboardWixCodeSdk'
	| 'dataWixCodeSdk'
	| 'debug'
	| 'debugDs'
	| 'domSelectors'
	| 'domStore'
	| 'dynamicPages'
	| 'dynamicRouteService'
	| 'editorAnimations'
	| 'editorElementsDynamicTheme'
	| 'editorNavigation'
	| 'editorPopups'
	| 'editorRouter'
	| 'editorWixCodeSdk'
	| 'elementorySupportWixCodeSdk'
	| 'embeddedInIframe'
	| 'environment'
	| 'environmentService'
	| 'environmentWixCodeSdk'
	| 'experiments'
	| 'externalComponent'
	| 'externalServices'
	| 'extraSiteHeight'
	| 'fedops'
	| 'fedopsLoggerService'
	| 'fedopsWixCodeSdk'
	| 'feedback'
	| 'fileUploader'
	| 'freemiumBanner'
	| 'headAppenderService'
	| 'headerContainer'
	| 'hoverBox'
	| 'imagePlaceholder'
	| 'imagePlaceholderService'
	| 'imageZoom'
	| 'interactions'
	| 'landingPage'
	| 'lightbox'
	| 'lightboxService'
	| 'linkUtilsService'
	| 'locationWixCodeSdk'
	| 'loginButton'
	| 'manifestManager'
	| 'mappersLegacyService'
	| 'measuresApi'
	| 'membersService'
	| 'menuContainer'
	| 'menusCurrentPage'
	| 'mobileActionsMenu'
	| 'mobileFullScreen'
	| 'modelUpdatesInvoker'
	| 'motion'
	| 'mpaNavigation'
	| 'multilingual'
	| 'multilingualService'
	| 'namedSignalsService'
	| 'nativeMobileWixCodeSdk'
	| 'navigation'
	| 'navigationManager'
	| 'navigationPhases'
	| 'onloadCompsBehaviors'
	| 'ooi'
	| 'ooiTpaSharedConfig'
	| 'pageAnchors'
	| 'pageContextService'
	| 'pageScroll'
	| 'pageTransitions'
	| 'pages'
	| 'pagesService'
	| 'paidPlansWixCodeSdk'
	| 'panorama'
	| 'passwordProtectedPage'
	| 'platform'
	| 'platformPubsub'
	| 'popupLink'
	| 'pricingPlansWixCodeSdk'
	| 'protectedPages'
	| 'provideComponentService'
	| 'provideCssService'
	| 'qaApi'
	| 'quickActionBar'
	| 'realtimeWixCodeSdk'
	| 'render'
	| 'renderIndicator'
	| 'renderer'
	| 'rendererConfiguration'
	| 'repeaters'
	| 'reporter'
	| 'router'
	| 'routerFetch'
	| 'routerService'
	| 'screenIn'
	| 'scrollRestoration'
	| 'scrollToAnchor'
	| 'sdkStateService'
	| 'searchBox'
	| 'searchWixCodeSdk'
	| 'seo'
	| 'seoService'
	| 'seoTpa'
	| 'seoWixCodeSdk'
	| 'serviceRegistrar'
	| 'sessionManager'
	| 'sessionManagerService'
	| 'siteAboveTheFoldService'
	| 'siteConfigurationService'
	| 'siteDeviceInfoService'
	| 'siteEditorContextService'
	| 'siteExperimentsService'
	| 'siteMembers'
	| 'siteMembersService'
	| 'siteMembersWixCodeSdk'
	| 'siteOverflow'
	| 'sitePagesService'
	| 'siteProvideCssService'
	| 'siteScrollBlocker'
	| 'siteScrollBlockerService'
	| 'siteLocaleService'
	| 'siteThemeService'
	| 'siteTopologyService'
	| 'siteUrlService'
	| 'siteWixCodeSdk'
	| 'sliderGallery'
	| 'sosp'
	| 'speculationRules'
	| 'ssrCache'
	| 'stickyToComponent'
	| 'stores'
	| 'storesWixCodeSdk'
	| 'structureApi'
	| 'styleUtilsService'
	| 'svgLoader'
	| 'telemetryWixCodeSdk'
	| 'testApi'
	| 'testService'
	| 'thunderboltInitializer'
	| 'thunderboltLogger'
	| 'tinyMenu'
	| 'topologyService'
	| 'tpa'
	| 'tpaCommons'
	| 'tpaModuleProvider'
	| 'tpaWorkerFeature'
	| 'translations'
	| 'translationsService'
	| 'triggersAndReactions'
	| 'urlService'
	| 'usedPlatformApis'
	| 'versionIndicator'
	| 'viewMode'
	| 'viewerManagerActionApi'
	| 'viewerManagerActionsAndBehaviorsApi'
	| 'viewerManagerAnimationApi'
	| 'viewerManagerBlocksApi'
	| 'viewerManagerByRefApi'
	| 'viewerManagerComponentApi'
	| 'viewerManagerComponentDetectorApi'
	| 'viewerManagerComponentPreviewApi'
	| 'viewerManagerCustomCss'
	| 'viewerManagerCustomElementsApi'
	| 'viewerManagerDataApi'
	| 'viewerManagerDiagnosticsApi'
	| 'viewerManagerDisplayedOnlyComponentsApi'
	| 'viewerManagerDocumentServicesModelApi'
	| 'viewerManagerExternalComponentsApi'
	| 'viewerManagerFontsApi'
	| 'viewerManagerLayoutApi'
	| 'viewerManagerLivePreviewApi'
	| 'viewerManagerMembersApi'
	| 'viewerManagerModesApi'
	| 'viewerManagerMultilingualApi'
	| 'viewerManagerNavigationApi'
	| 'viewerManagerPagesApi'
	| 'viewerManagerPlatformApi'
	| 'viewerManagerPreviewRegionApi'
	| 'viewerManagerQueryApi'
	| 'viewerManagerRealTimeConfigApi'
	| 'viewerManagerRenderFlagsApi'
	| 'viewerManagerRendererModelApi'
	| 'viewerManagerResponsiveApi'
	| 'viewerManagerRuntimeApi'
	| 'viewerManagerRuntimeLayoutApi'
	| 'viewerManagerScopesApi'
	| 'viewerManagerScrollApi'
	| 'viewerManagerStructureApi'
	| 'viewerManagerStylableApi'
	| 'viewerManagerSvgApi'
	| 'viewerManagerTpaApi'
	| 'viewerManagerUpdateStatusApi'
	| 'viewerManagerVariantsApi'
	| 'viewerManagerVeloApi'
	| 'visibility'
	| 'warmupData'
	| 'welcomeScreen'
	| 'widget'
	| 'widgetWixCodeSdk'
	| 'windowMessageRegistrar'
	| 'windowScroll'
	| 'windowWixCodeSdk'
	| 'wixCustomElementComponent'
	| 'wixEcomFrontendWixCodeSdk'
	| 'wixEmbedsApi'
	| 'wixEventsWixCodeSdk'
	| 'wixapps'
	| 'wrichtextWrapOnAdd'

export type FeaturesConfig = Partial<Record<FeatureName | '__componentsConfig__', any>>
export type PageFeaturesConfig = Partial<Omit<Record<FeatureName | '__componentsConfig__', any>, 'render'>> & {
	render: RenderConfig
}
